import React, { useContext, useEffect, useState } from "react";
import ReferralCabinetInfoSection from "./info/ReferralCabinetInfoSection";
import ReferralHeader from "./ReferralHeader";
import ReferralPromocodeBenefitRow from "./ReferralPromocodeBenefitRow";
import ReferralPromocodeCard from "./ReferralPromocodeCard";
import ReferralScreenHeaderSection from "./ReferralScreenHeaderSection";
import "./ReferralCabinetScreen.css";
import '../mainscreen/MainScreen.css';
import Footer from "../mainscreen/footer/Footer";
import { ReferralAppContext } from "./ReferralApp";
import ReferralCabinetConditionsFooter from "./ReferralCabinetConditionsFooter";
import { trackGoal } from "../helpers/tracker";
import YandexProjectLogo from "../mainscreen/footer/YandexProjectLogo";
import FooterCopyright from "../mainscreen/footer/FooterCopyright";

export default function ReferralCabinetScreen() {
    const appContext = useContext(ReferralAppContext);
    const info = appContext?.b2cInfo;
    const session = appContext?.session;
    const isMobile = appContext?.isMobile ?? false;
    const isPlusEnabled = session?.user.plus?.is_activated ?? false;
    const isLoggedIn = appContext?.isLoggedIn ?? false;

    return <div className={isMobile ? "Referral_cabinet_screen_mobile" : "Referral_cabinet_screen"}>
        <ReferralScreenHeaderSection session={session} isMobile={isMobile} />
        <ReferralCabinetInfoSection isMobile={isMobile} referral={appContext?.referral} settings={appContext?.referralSettings!} />
        <ReferralCabinetConditionsFooter isMobile={isMobile} isPlusEnabled={isPlusEnabled} />
        {
            !isMobile &&
            <>
                <Footer mobile={false}
                    footer={info!.footer}
                    city={info!.cities[0]}
                    cities={info!.cities}
                    constants={info!.constants}
                    onSelected={(c) => { }}
                />
                <FooterCopyright/>
            </>
        }
        {(!isPlusEnabled && isLoggedIn) && <PlusButton isMobile={isMobile} />}
    </div>
}

function PlusButton(props: { isMobile: boolean }) {
    const [showPlus, setShowPlus] = useState<boolean>(false)
    const [plusButtonVisible, setPlusButtonVisible] = useState<boolean>(false)

    // @ts-ignore
    const handleScroll = (event) => {
        const scroll = document.body.scrollTop || document.documentElement.scrollTop
        if (props.isMobile) {
            const atBottomOfPage = document.body.scrollHeight - scroll <= document.body.clientHeight + 20
            setPlusButtonVisible(scroll > 300 && !atBottomOfPage)
        } else {
            const atBottomOfPage = document.body.scrollHeight - scroll <= document.body.clientHeight + 600
            setPlusButtonVisible(scroll > 300 && !atBottomOfPage)
        }
    }

    useEffect(() => {
        setShowPlus(plusButtonVisible)
    }, [plusButtonVisible]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    function openYandexPlus() {
        trackGoal("referral_cabinet_open_plus");
        window.open("https://plus.yandex.ru/");
    }

    var className = props.isMobile ? "plus_button_mobile" : "plus_button";
    className += (showPlus ? " plus_button_slide_in" : " plus_button_slide_out")

    return <button className={className} onClick={() => openYandexPlus()}>
        Включить Плюс и копить баллы
    </button>
}